module.exports = __webpack_public_path__ + "img/The-Bit-Foundry-thebitfoundry.663a61ae.png";